import { useEffect, useRef } from 'react';

import { StatusOfShootingEnum } from 'src/models/Camera/Shooting/Shooting.model';

export const CAMERA_SHOOT_TIMEOUT_MS = 60_000;
export const IMAGE_POLL_TIMEOUT_MS = 30_000;
export const STALL_TIMEOUT_MS = CAMERA_SHOOT_TIMEOUT_MS + IMAGE_POLL_TIMEOUT_MS;

interface UseCaptureStallDetectorOptions {
  enabled?: boolean;
  isCapturing: boolean;
  captureState: StatusOfShootingEnum | undefined;
  isPupilSmall: boolean;
  timeoutMs: number;
  onTimeout: () => void;
}

export function useCaptureStallDetector({
  enabled = true,
  isCapturing,
  captureState,
  isPupilSmall,
  timeoutMs,
  onTimeout,
}: UseCaptureStallDetectorOptions): void {
  const onTimeoutRef = useRef(onTimeout);
  useEffect(() => {
    onTimeoutRef.current = onTimeout;
  });

  useEffect(() => {
    if (!enabled || !isCapturing || isPupilSmall) return;

    const id = setTimeout(() => onTimeoutRef.current(), timeoutMs);
    return () => clearTimeout(id);
  }, [enabled, isCapturing, captureState, isPupilSmall, timeoutMs]);
}
